module.exports = __webpack_public_path__ + "static/images/filled-dot.b1f6ad6fdce824133c4b7ea32bbcfbce.svg";